module.exports = __webpack_public_path__ + "b6a6a551f2ef8599238b10a54dd483cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_03.jpg
// module id = 623
// module chunks = 0